/**
 * Data store for storing all the hardcoded filter data like data for Package Direction filters. This is for 
 * initalising the fiter context
 */


 //Map <Display Value, Value>
 export const PackageTypes = {
  
  "Core Volume" : "Delivery",
  "Ship With Amazon" : "MFNPickup",
  "Undeliverables" : "Delivery",
  "Customer Return" : ["CReturns", "Abandoned"],
 }

 export const PackageTypes_Reverse = {

  "Ship With Amazon" : ["Ship With Amazon"],
  "Undeliverables" : ["Undeliverables"],
  "Customer Return" : ["Customer Return"],
  "Waste Transfer Note" : ["Waste Transfer Note"]

 }

 //Creating dynamic package status filter
 //Map of Display value and internal state. Currently modelling it as list till we integrate with backend.
 // Please add entry in sorted order for Tier 2 Search filter
 export const PackageStatuses = [
  "Arrived",
  "Delivered",
  "Delivery Failed",
  "Delivery Rejected",
  "Depart Problem Solve",
  "Drop Failed",
   "Held",
   "Inducted",
   "Induct Problem Solve",
   "In Transit (DS -> Customer)",
   "In Transit (DS -> DS)",
   "In Transit (DS -> XPT)",
   "In Transit (Seller -> DS)",
   "In Transit (Customer/Locker -> DS)",
   "In Transit (FC -> DS)",
   "In Transit (DS -> FC/Seller)",
   "Manifest Cancelled",
   "Manifested (FC -> DS)",
   "Manifested (Seller/Locker -> DS)",
   "Marked as Lost",
   "Marked as Missing",
   "Stow Buffered",
   "Jackpot Buffered",
   "Marked for Reprocess",
   "Picked",
   "Pickup Failed",
   "Pick Problem Solve",
   "Problem Solve",
   "Received (DS -> FC)",
   "Received (DS -> Customer)",
   "RTS Received (DS -> Customer)",
   "Self-Serve Return",
   "Associate Debrief",
   "Reverse Inducted — Reattemptable",
   "Reverse Inducted — Stowable",
   "Stow Problem Solve",
   "Staged (DS -> Customer)",
   "Staged (DS -> DS)",
   "Stowed (DS -> Customer)",
   "Stowed (DS -> FC)",
   "Rescheduled",
   "Customer Notes Updated",
   "Cancelled Pickups",
   "Removed",
   "Returned To Seller",
   "Marked for Reprocess (DS -> FC)",
   "Pending Verification (DS -> FC)",
   "Cash With Associate",
   "Cash At Station",
   "Disputed Scan",
   "Manifested (Seller DropOff)",
 ]

 export const STATE_TO_DIRECTION_MAP = {

  "Manifested": ["FC -> DS", "Seller/Locker -> DS"],
  "In Transit": ["DS -> Customer", "DS -> XPT", "Seller/Locker -> DS"],
  "Stowed" : ["DS -> Customer", "DS -> FC"],
  "Received" : ["DS -> Customer", "DS -> FC"]
 }

 export const TimeUnits = [
    "Minutes"
 ]

 export const VIEW_TO_FILTERS_MAP = {

   "AGEING_VIEW_REVERSE" : ["LEG", "EAD", "PACKAGE_TYPE_REVERSE", "SHIP_DATE"],
   "AGEING_VIEW_FORWARD" : ["LEG", "EAD", "SHIP_DATE"],
   "RTS_VIEW" : [ "EAD", "PACKAGE_TYPE_REVERSE", "SHIP_DATE"],
   "PACKAGE_DRILLDOWN" : ["CYCLE", "EAD", "PACKAGE_TYPE", "DWELL_TIME", "AGEING_TIME", "PACKAGE_STATUS", "SAME_DAY", "APPLY_FILTER", "LOCAL_STATION_ARRIVAL_TIME", "SHIP_DATE", "CPT"],
   "DWELLING_VIEW" : ["EAD", "SHIP_DATE"],
   "SD_DWELLING_VIEW": ["DELIVERY_WINDOW", "EAD"]

 }

export const VIEW_TO_STATIC_FILTERS_MAP = {

    "AGEING_VIEW_REVERSE" : ["leg"],
    "AGEING_VIEW_FORWARD" : ["leg"],
    "RTS_VIEW" : [],
    "PACKAGE_DRILLDOWN" : ["page", "isApplyFilterClicked", "dwellStartTime", "dwellEndTime", "dwellStart",
        "dwellEnd", "dwellStartTimeUnit", "dwellEndTimeUnit", "stationTimeZone"],
    "DWELLING_VIEW" : [],
    "SD_DWELLING_VIEW": []
}

 //start to end
 export const DAY_TO_DWELLTIME_MAP = {
   "1_DAY" : ["1", "0"],
   "2_DAY" : ["2", "1"],
   "3_DAY" : ["3", "2"],
   "4_DAY" : ["4", "3"],
   "5_DAY" : ["30", "4"],
   "TOTAL" : ["30", "0"]
 }

 export const REASON_TO_STATUS_MAPPING = {

   "FDD": "FDD",
   "Wrong Cycle Induct": "Wrong Cycle Induct",
   "Sidelined Closed": "Sidelined Closed",
   "Pending Customer Feedback" : "Pending Customer Feedback",
   "Inaccessible pickup location":"Pickup Failed", 
   "Locker issue":"Pickup Failed", 
   "Shipment not ready":"Pickup Failed",
   "Cancelled Pickups": "Cancelled Pickups",
   "Manifest Cancelled": "Cancelled Pickups",
   "Collected by customer": "Cancelled Pickups"
 }

export default function getValuesForDataMap(inputMap) {

   return Object.entries(inputMap).map(entry => {return entry[1]});

}

/**
 * This function to call backend with directions
 * @param {} leg 
 */
export function getLegToDirection(leg) {
    
      switch(leg) {
          case "FORWARD" : return ["FC -> DS", "DS -> DS", "DS -> Customer"]
          case "REVERSE" : return ["Seller/Locker -> DS", "DS -> FC", "Locker -> DS"]
          default : return []
      
 }}
 //for tier 1 to 2
 export function getDirectionInTier2(leg, state) {

  let direction = STATE_TO_DIRECTION_MAP[state] ? STATE_TO_DIRECTION_MAP[state].filter(x => getLegToDirection(leg.toUpperCase()).includes(x)) : [];
  return direction[0] ? state.concat(" (").concat(direction[0]).concat(")") : state


 }



// WEBPACK FOOTER //
// ./src/commons/dataStore/FilterDataStore.js